import { FormControl, InputLabel, Select, TextField, makeStyles } from '@material-ui/core';

import { USER_ROLE_LABELS } from '../../constants/user-role-labels.constants';
import {
  USER_STATUS_FILTERS,
  USER_STATUS_FILTER_LABELS,
  UserStatusFilter,
} from '../../constants/user-status-filter.constants';
import { UserRole, UserRoles } from '../../types/user-role.type';

const SEARCH_INPUT_ID = 'users-search';
const ROLE_FILTER_INPUT_ID = 'users-role-filter';
const STATUS_FILTER_INPUT_ID = 'users-status-filter';

export const ALL_ROLES = 'all';

export type RoleFilter = UserRole | typeof ALL_ROLES;

interface UsersListFiltersProps {
  search: string;
  roleFilter: RoleFilter;
  statusFilter: UserStatusFilter;
  onSearchChange: (value: string) => void;
  onRoleFilterChange: (value: RoleFilter) => void;
  onStatusFilterChange: (value: UserStatusFilter) => void;
}

const useStyles = makeStyles({
  filters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
  },
});

export function UsersListFilters({
  search,
  roleFilter,
  statusFilter,
  onSearchChange,
  onRoleFilterChange,
  onStatusFilterChange,
}: UsersListFiltersProps) {
  const classes = useStyles();

  return (
    <section className={classes.filters}>
      <TextField
        id={SEARCH_INPUT_ID}
        size="small"
        label="Rechercher"
        type="text"
        variant="outlined"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <FormControl variant="outlined" size="small">
        <InputLabel htmlFor={ROLE_FILTER_INPUT_ID}>Rôle</InputLabel>
        <Select
          native
          label="Rôle"
          value={roleFilter}
          inputProps={{ id: ROLE_FILTER_INPUT_ID }}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            onRoleFilterChange(event.target.value as RoleFilter)
          }
        >
          <option value={ALL_ROLES}>Tous</option>
          {Object.values(UserRoles).map((role) => (
            <option key={role} value={role}>
              {USER_ROLE_LABELS[role]}
            </option>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small">
        <InputLabel htmlFor={STATUS_FILTER_INPUT_ID}>Statut</InputLabel>
        <Select
          native
          label="Statut"
          value={statusFilter}
          inputProps={{ id: STATUS_FILTER_INPUT_ID }}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            onStatusFilterChange(event.target.value as UserStatusFilter)
          }
        >
          {USER_STATUS_FILTERS.map((status) => (
            <option key={status} value={status}>
              {USER_STATUS_FILTER_LABELS[status]}
            </option>
          ))}
        </Select>
      </FormControl>
    </section>
  );
}
